import React, { Component } from 'react';
import Banner from '../../../components/UI/PolicyPage/PolicyPage';
import {withTranslation } from 'react-i18next';
import Head from '../../../components/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary/Auxiliary';

class PersonalData extends Component {
    render(){
        return(
            <Auxiliary>
                <Head id="personal-data"/>
                <Banner 
                    {...this.props}
                    page="personalData"
                />
            </Auxiliary>
        );
    }
}

export default withTranslation()(PersonalData);